module.exports = __webpack_public_path__ + "static/media/Growing tray for microgreens or Fodder tray2.7ee68560.webp";